// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQBlock_wrapper___81ry","title":"FAQBlock_title__6vNyX"};